export default __webpack_public_path__ + "media/samples/Past_Live_Streams-a643960a.jpeg";